<div class="onboarding-page-overlay" *ngIf="onboardingProvider.showOnboarding"></div>

<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    *ngIf="!windowService.isDesktopRes"
    [class]="extraClass + (!loaded ? ' suppress-loading-bar' : '')"
    [title]="'Maintenance'"
    [linkIcon]="'add-maintenance'"
    [showLinkIcon]="true"
    (linkAction)="addIssueReport()"
    [customBack]="backPage" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [hasBottomNav]="true" [ngClass]="{'flex-content': windowService.isDesktopRes}">

    <tidy-error-message
      *ngIf="!loaded && errorMessage"
      [text]="errorMessage" />

    <tidy-tasks-filter
      *ngIf="windowService.isDesktopRes || loaded"
      [addresses]="addressResponse"
      [issueReportTypes]="issueReportTypes"
      [initialPropertyFilter]="initialAddressFilter"
      [showAboutThisPage]="false"
      (filter)="onFilterChanges($event)"
      (searchChange)="onSearchChanges($event)"
      (addIssue)="addIssueReport()"
      (exportCSV)="exportCSV()"
      [showLoadingSpinner]="showLoadingSpinner" />

    <!-- First-load skeleton — mirrors the loaded layout exactly (same
         .issue-columns / .mobile-status-toggle wrappers and tidy-card
         dimensions) so the real content replaces it in place without
         anything shifting. The skeletons float in on landing; the real
         content swaps in with no animation. `loaded` never flips back
         after the first load, so background refreshes and route reuse
         can't replay it. -->
    @if (!loaded && !errorMessage) {
      <ng-template #skeletonCard>
        <tidy-card class="sk-card">
          <tidy-row [alignLastItemRight]="true">
            <ion-skeleton-text [animated]="true" class="sk-card-title" />
            <ion-skeleton-text [animated]="true" class="sk-avatar" />
          </tidy-row>
          <tidy-row class="no-padding" [alignLastItemRight]="true">
            <ion-skeleton-text [animated]="true" class="sk-urgency" />
            <ion-skeleton-text [animated]="true" class="sk-address" />
            <ion-skeleton-text [animated]="true" class="sk-avatar" />
          </tidy-row>
        </tidy-card>
      </ng-template>
      @if (windowService.isDesktopRes) {
        <div class="issue-columns tasks-skeleton" aria-hidden="true">
          @for (column of skeletonBoard; track $index) {
            <div class="issue-columns_column">
              <div class="issue-columns_column_column-title">
                <ion-skeleton-text [animated]="true" class="sk-column-title" />
              </div>
              <div class="example-viewport sk-viewport">
                @for (card of column; track card) {
                  <ng-container *ngTemplateOutlet="skeletonCard" />
                }
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="mobile-filter-row-skeleton tasks-skeleton" aria-hidden="true">
          <ion-skeleton-text [animated]="true" class="sk-search" />
          <ion-skeleton-text [animated]="true" class="sk-icon-button" />
          <ion-skeleton-text [animated]="true" class="sk-text-button" />
        </div>
        <div class="mobile-status-toggle tasks-skeleton" aria-hidden="true">
          @for (option of [1, 2, 3, 4]; track option) {
            <ion-skeleton-text [animated]="true" class="sk-toggle-option" />
          }
        </div>
        <div class="example-viewport sk-viewport sk-viewport-mobile tasks-skeleton" aria-hidden="true">
          @for (card of [1, 2, 3, 4, 5, 6, 7, 8]; track card) {
            <ng-container *ngTemplateOutlet="skeletonCard" />
          }
        </div>
      }
    }

    <ng-container *ngIf="loaded">

      <tidy-error-message
        *ngIf="errorMessage"
        [text]="errorMessage" />

      <div class="issue-columns" cdkDropListGroup *ngIf="windowService.isDesktopRes">
        <ng-container *ngFor="let column of columns; trackBy: trackByColumn">
          <div [id]="column" class="issue-columns_column" cdkDropList (cdkDropListDropped)="dropped($event)">
            <div class="issue-columns_column_column-title">
              <tidy-text
                [header]="columnTitlesByKeys[column]" />
            </div>
            <cdk-virtual-scroll-viewport
              itemSize="70"
              class="example-viewport"
              *ngIf="loaded">
              <tidy-card
                (click)="goToTask(issue)"
                [id]="'issue-card-' + issue?.id"
                cdkDrag
                [cdkDragData]="issue"
                [ngClass]="{'dragging-preview': isDragging}"
                (cdkDragStarted)="isDragging = true"
                (cdkDragEnded)="isDragging = false"
                *cdkVirtualFor="let issue of issuesColumns[column]; trackBy: trackByIssue">
                <tidy-row [alignLastItemRight]="true">
                  <tidy-text
                    [ngStyle]="issue?.checkedUsers?.length > 1 ? {'max-width': '15ch'} : {'max-width': '50ch'}"
                    [body]="issue?.title" />
                  <div style="display: flex; align-items: center; justify-content: flex-end;">
                    <tidy-image
                      *ngIf="!issue?.checkedUsers?.length"
                      mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" #desktopUserMenuTrigger1="matMenuTrigger"
                      [src]="'assets/img/assign.svg'"
                      class="header-size secondary-text-icon no-right-margin" />
                    <div *ngIf="getUserIcon(issue?.checkedUsers) == 'user'" class="tasks-initials" [ngClass]="!issue?.checkedUsers?.length ? 'thirty-percent-opacity button-hover' : 'button-hover'" mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" #desktopUserMenuTrigger2="matMenuTrigger" [style.background]="util.getAvatarGradient(issue?.checkedUsers[0]?.name || 'BA')">
                      {{ issue?.checkedUsers[0]?.name | initials }}
                    </div>
                    <tidy-image
                      *ngIf="getUserIcon(issue?.checkedUsers) == 'concierge'"
                      class="button-hover no-right-margin" style="width: 18px" mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" #desktopUserMenuTrigger3="matMenuTrigger"
                      [src]="'assets/img/concierge.svg'" />
                    <tidy-text
                      style="margin-left: 3px"
                      *ngIf="issue?.checkedUsers?.length > 1"
                      [body]="'+' + issue?.checkedUsers?.length - 1" />
                    <mat-menu #menu="matMenu">
                      <ng-container *ngFor="let user of issue?.allUsers; trackBy: trackByUser">
                        <button mat-menu-item>
                          <mat-checkbox
                            class="checkbox"
                            [checked]="user?.checked"
                            (click)="$event.stopPropagation()"
                            (change)="checkOrUncheckPerson(issue, user, $event)">
                            {{user?.name}}
                          </mat-checkbox>
                        </button>
                      </ng-container>
                    </mat-menu>
                  </div>
                </tidy-row>
                <tidy-row class="no-padding" [alignLastItemRight]="true">
                  <tidy-image
                    class="button-hover" mat-icon-button [matMenuTriggerFor]="urgencyMenu" #urgencyMenuTrigger="matMenuTrigger" (click)="$event.stopPropagation()"
                    [src]="getIssueHeaderIcon(issue)"
                     />
                  <mat-menu #urgencyMenu="matMenu">
                    <ng-container *ngFor="let urgency of urgencies; trackBy: trackByUrgency">
                      <button mat-menu-item class="tree-node-padding" (click)="selectUrgency(issue, urgency, $event)">
                        <tidy-image
                          [src]="urgency.icon"
                          class="header-size" />
                        {{urgency?.viewValue}}
                      </button>
                    </ng-container>
                  </mat-menu>
                  <tidy-text
                    mat-icon-button class="no-ripple button-hover" [matMenuTriggerFor]="addressMenu" #addressMenuTrigger="matMenuTrigger" (click)="$event.stopPropagation()"
                    [secondaryBody]="getAddressName(issue)" />
                  <mat-menu #addressMenu="matMenu">
                    <ng-container *ngFor="let address of addressFilter; trackBy: trackByAddress">
                      <button mat-menu-item class="tree-node-padding" (click)="selectAddress(issue, address, $event)">
                        {{address?.viewValue}}
                      </button>
                    </ng-container>
                  </mat-menu>
                  <div>
                    <tidy-image
                      *ngIf="!issue?.checkedJobs?.length"
                      mat-icon-button [matMenuTriggerFor]="jobMenu" (click)="showJobMenu($event, issue)" #desktopJobMenuTrigger="matMenuTrigger"
                      [src]="'assets/img/calendar-plus.svg'"
                      class="header-size secondary-text-icon no-right-margin" />
                    <ion-chip class="job-chip no-padding"*ngIf="issue?.checkedJobs?.length" mat-icon-button [matMenuTriggerFor]="jobMenu" (click)="showJobMenu($event, issue)" #desktopJobMenuTrigger2="matMenuTrigger">
                      <tidy-image
                        [src]="issue?.checkedJobs[0]?.icon_url"
                        style="height: 25px" />
                      <tidy-image
                        *ngIf="issue?.checkedJobs[0]?.status?.icon_type == 'image'"
                        [src]="issue?.checkedJobs[0]?.status?.icon"
                        [ngClass]="issue?.checkedJobs[0]?.status?.class ? issue?.checkedJobs[0]?.status?.class : ''"
                        style="height: 25px" />
                      <div
                        *ngIf="issue?.checkedJobs[0]?.status?.icon_type == 'initials'"
                        [ngClass]="issue?.checkedJobs[0]?.status?.class"
                        [style.background]="util.getAvatarGradient(issue?.checkedJobs[0]?.status?.initials || 'BA')">
                        {{issue?.checkedJobs[0]?.status?.initials | uppercase}}
                      </div>
                    </ion-chip>
                    <mat-menu #jobMenu="matMenu" style="max-width: 600px !important;">
                      <div style="padding: 10px; border-bottom: 1px solid #e0e0e0;" (click)="$event.stopPropagation()">
                        <form [formGroup]="jobSearchForm" novalidate action="#">
                          <tidy-search-input
                            #jobSearchInput
                            formControlName="search"
                            [placeholder]="'Search jobs'"
                            [icon]="'assets/svg/search-outline.svg'"
                            (click)="$event.stopPropagation()"
                            (focus)="$event.stopPropagation()"
                            (keydown)="$event.stopPropagation()" />
                        </form>
                      </div>
                      <ng-container *ngFor="let job of issue?.filteredJobs; trackBy: trackByJob">
                        <button mat-menu-item class="tree-node-padding" style="display: flex; align-items: center; justify-content: space-between; width: 100%">
                          <mat-checkbox
                            class="checkbox"
                            (click)="$event.stopPropagation()"
                            [checked]="job?.checked"
                            (change)="checkOrUncheckJob(issue, job, $event)">
                            <tidy-text
                              [body]="job?.name" /><span>&nbsp;</span>
                            <tidy-text
                              [helper]="'-'" /><span>&nbsp;</span>
                            <tidy-text
                              [helper]="job?.service_name"
                              style="margin-right: 5px" />
                          </mat-checkbox>
                          <tidy-image
                            [src]="'assets/img/chevron-right.svg'"
                            class="right-item chevron-icon no-right-margin"
                            (action)="goToJob(job, issue, $event)" />
                        </button>
                      </ng-container>
                      <div *ngIf="issue?.filteredJobs && !issue?.filteredJobs?.length && issue?.allJobs?.length" style="margin: 10px;">
                        <tidy-text [helper]="'<i>No results</i>'" />
                      </div>
                      <div *ngIf="!issue?.allJobs?.length && issue?.allJobs" style="margin: 10px;">
                        <tidy-text [helper]="'<i>No jobs booked</i>'">></tidy-text>
                      </div>
                      <div *ngIf="!issue?.allJobs" style="margin: 10px;">
                        <tidy-text [helper]="'Loading jobs...'">></tidy-text>
                      </div>
                      <mat-divider />
                      <tidy-row class="vertical-align-center extra-top-padding extra-bottom-padding" style="margin-left: 7px; margin-right: 10px">
                        <tidy-image
                          [src]="'assets/svg/add-circle-outline.svg'"
                          class="header-size" />
                        <tidy-text
                          [actionBody]="'Add Job'"
                          (action)="goToAddJob(issue)" />
                      </tidy-row>
                    </mat-menu>
                  </div>
                </tidy-row>
              </tidy-card>
              @if (column === 'reported') {
                @for (suggestion of maintenanceSuggestions; track suggestion.id) {
                  <task-suggestion-card
                    type="suggested"
                    [title]="suggestion.title | translate"
                    [priorityIcon]="getIssueHeaderIcon({urgency: suggestion.urgency || 'normal'})"
                    [address]="suggestion.address_name || addressFilter?.[0]?.viewValue || ''"
                    [showArrowOnly]="false"
                    (cardClick)="goToSuggestion(suggestion)"
                    (rejectClick)="rejectSuggestion(suggestion)"
                    (acceptClick)="goToSuggestion(suggestion)" />
                }
                @if (!maintenanceSuggestions?.length && !hideSuggestedCard) {
                  <task-suggestion-card
                    type="suggested"
                    [title]="hasAssets ? ('Log maintenance for your assets' | translate) : ('Add assets to get smart maintenance' | translate)"
                    [priorityIcon]="'assets/img/normal-priority.svg'"
                    [address]="addressFilter?.[0]?.viewValue || 'Select Property'"
                    [showArrowOnly]="!hasAssets"
                    (cardClick)="hasAssets ? addIssueReport() : goToAssets()"
                    (rejectClick)="hideSuggestedCard = true"
                    (acceptClick)="hasAssets ? addIssueReport() : goToAssets()" />
                }
              }
            </cdk-virtual-scroll-viewport>
          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="!windowService.isDesktopRes">
        <div class="mobile-status-toggle">
          <button
            class="toggle-option"
            [class.active]="selectedStatus === 'reported'"
            (click)="updatedStatusFilter('reported')">
            New ({{issuesColumns['reported']?.length || 0}})
          </button>
          <button
            class="toggle-option"
            [class.active]="selectedStatus === 'approved'"
            (click)="updatedStatusFilter('approved')">
            Approved ({{issuesColumns['approved']?.length || 0}})
          </button>
          <button
            class="toggle-option"
            [class.active]="selectedStatus === 'in_progress'"
            (click)="updatedStatusFilter('in_progress')">
            Doing ({{issuesColumns['in_progress']?.length || 0}})
          </button>
          <button
            class="toggle-option"
            [class.active]="selectedStatus === 'done'"
            (click)="updatedStatusFilter('done')">
            Done ({{issuesColumns['done']?.length || 0}})
          </button>
        </div>

        <cdk-virtual-scroll-viewport
          itemSize="70"
          class="example-viewport"
          *ngIf="loaded">
          <ng-container
            [id]="'issue-card-' + issue?.id"
            class="drag-item issue-card"
            *cdkVirtualFor="let issue of issuesColumns[selectedStatus]; trackBy: trackByIssue">
            <tidy-card
              (click)="goToTask(issue)"
              class="drag-item issue-card-mobile">
              <tidy-row [alignLastItemRight]="true">
                <tidy-text
                  [ngStyle]="issue?.checkedUsers?.length > 1 ? {'max-width': '15ch'} : {'max-width': '50ch'}"
                  [body]="issue?.title" />
                <div class="mobile-user-assign">
                  <tidy-image
                    *ngIf="!issue?.checkedUsers?.length"
                    mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" #mobileUserMenuTrigger="matMenuTrigger"
                    [src]="'assets/img/assign.svg'"
                    class="header-size secondary-text-icon no-right-margin" />
                  <div *ngIf="getUserIcon(issue?.checkedUsers) == 'user'" class="tasks-initials" [ngClass]="!issue?.checkedUsers?.length ? 'thirty-percent-opacity button-hover' : 'button-hover'" mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" [style.background]="util.getAvatarGradient(issue?.checkedUsers[0]?.name || 'BA')">
                    {{ issue?.checkedUsers[0]?.name | initials }}
                  </div>
                  <tidy-image
                    *ngIf="getUserIcon(issue?.checkedUsers) == 'concierge'"
                    class="button-hover no-right-margin" style="width: 18px" mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                    [src]="'assets/img/concierge.svg'" />
                  <tidy-text
                    style="margin-left: 3px"
                    *ngIf="issue?.checkedUsers?.length > 1"
                    [body]="'+' + issue?.checkedUsers?.length - 1" />
                  <mat-menu #menu="matMenu">
                    <ng-container *ngFor="let user of issue?.allUsers; trackBy: trackByUser">
                      <button mat-menu-item>
                        <mat-checkbox
                          class="checkbox"
                          [checked]="user?.checked"
                          (click)="$event.stopPropagation()"
                          (change)="checkOrUncheckPerson(issue, user, $event)">
                          {{user?.name}}
                        </mat-checkbox>
                      </button>
                    </ng-container>
                  </mat-menu>
                </div>
              </tidy-row>
              <tidy-row class="no-padding" [alignLastItemRight]="true">
                <tidy-image
                  class="button-hover"
                  [src]="getIssueHeaderIcon(issue)" />
                <tidy-text
                  [secondaryBody]="getAddressName(issue)" />
                <div>
                  <tidy-image
                    *ngIf="!issue?.checkedJobs?.length"
                    mat-icon-button [matMenuTriggerFor]="jobMenu" (click)="showJobMenu($event, issue)" #mobileJobMenuTrigger="matMenuTrigger"
                    [src]="'assets/img/calendar-plus.svg'"
                    class="header-size secondary-text-icon no-right-margin" />
                  <ion-chip class="job-chip no-padding" *ngIf="issue?.checkedJobs?.length" mat-icon-button [matMenuTriggerFor]="jobMenu" (click)="showJobMenu($event, issue)">
                    <tidy-image
                      [src]="issue?.checkedJobs[0]?.icon_url"
                      style="height: 25px" />
                    <tidy-image
                      *ngIf="issue?.checkedJobs[0]?.status?.icon_type == 'image'"
                      [src]="issue?.checkedJobs[0]?.status?.icon"
                      [ngClass]="issue?.checkedJobs[0]?.status?.class ? issue?.checkedJobs[0]?.status?.class : ''"
                      style="height: 25px" />
                    <div
                      *ngIf="issue?.checkedJobs[0]?.status?.icon_type == 'initials'"
                      [ngClass]="issue?.checkedJobs[0]?.status?.class"
                      [style.background]="util.getAvatarGradient(issue?.checkedJobs[0]?.status?.initials || 'BA')">
                      {{issue?.checkedJobs[0]?.status?.initials | uppercase}}
                    </div>
                  </ion-chip>
                  <mat-menu #jobMenu="matMenu" style="max-width: 600px !important;">
                    <div style="padding: 10px; border-bottom: 1px solid #e0e0e0;" (click)="$event.stopPropagation()">
                      <form [formGroup]="jobSearchForm" novalidate action="#">
                        <tidy-search-input
                          #jobSearchInput
                          formControlName="search"
                          [placeholder]="'Search jobs'"
                          [icon]="'assets/svg/search-outline.svg'"
                          (click)="$event.stopPropagation()"
                          (focus)="$event.stopPropagation()"
                          (keydown)="$event.stopPropagation()" />
                      </form>
                    </div>
                    <ng-container *ngFor="let job of issue?.filteredJobs; trackBy: trackByJob">
                      <button mat-menu-item class="tree-node-padding" style="display: flex; align-items: center; justify-content: space-between; width: 100%">
                        <mat-checkbox
                          class="checkbox"
                          (click)="$event.stopPropagation()"
                          [checked]="job?.checked"
                          (change)="checkOrUncheckJob(issue, job, $event)">
                          <tidy-text
                            [body]="job?.name" /><span>&nbsp;</span>
                          <tidy-text
                            [helper]="'-'" /><span>&nbsp;</span>
                          <tidy-text
                            [helper]="job?.service_name"
                            style="margin-right: 5px" />
                        </mat-checkbox>
                        <tidy-image
                          [src]="'assets/img/chevron-right.svg'"
                          class="right-item chevron-icon no-right-margin"
                          (action)="goToJob(job, issue, $event)" />
                      </button>
                    </ng-container>
                    <div *ngIf="issue?.filteredJobs && !issue?.filteredJobs?.length && issue?.allJobs?.length" style="margin: 10px;">
                      <tidy-text [helper]="'<i>No results</i>'" />
                    </div>
                    <div *ngIf="!issue?.allJobs?.length && issue?.allJobs" style="margin: 10px;">
                      <tidy-text [helper]="'<i>No jobs booked</i>'">></tidy-text>
                    </div>
                    <div *ngIf="!issue?.allJobs" style="margin: 10px;">
                      <tidy-text [helper]="'Loading jobs...'">></tidy-text>
                    </div>
                    <mat-divider />
                    <tidy-row class="vertical-align-center extra-top-padding extra-bottom-padding" style="margin-left: 7px; margin-right: 10px">
                      <tidy-image
                        [src]="'assets/svg/add-circle-outline.svg'"
                        class="header-size" />
                      <tidy-text
                        [actionBody]="'Add Job'"
                        (action)="goToAddJob(issue)" />
                    </tidy-row>
                  </mat-menu>
                </div>
              </tidy-row>
              <tidy-row *ngIf="issue?.due_date" class="vertical-align-center extra-top-padding">
                <tidy-image
                  [src]="'assets/svg/calendar-outline-white.svg'"
                  class="body-size" />
                <tidy-text
                  [smallBody]="getIssueDueDate(issue?.due_date)"
                  [ngClass]="{'red': isDueDateInPast(issue?.due_date)}" />
              </tidy-row>
            </tidy-card>
          </ng-container>
          @if (selectedStatus === 'reported') {
            @for (suggestion of maintenanceSuggestions; track suggestion.id) {
              <task-suggestion-card
                type="suggested"
                [title]="suggestion.title | translate"
                [priorityIcon]="getIssueHeaderIcon({urgency: suggestion.urgency || 'normal'})"
                [address]="suggestion.address_name || addressFilter?.[0]?.viewValue || ''"
                [showArrowOnly]="false"
                (cardClick)="goToSuggestion(suggestion)"
                (rejectClick)="rejectSuggestion(suggestion)"
                (acceptClick)="goToSuggestion(suggestion)" />
            }
            @if (!maintenanceSuggestions?.length && !hideSuggestedCard) {
              <task-suggestion-card
                type="suggested"
                [title]="hasAssets ? ('Log maintenance for your assets' | translate) : ('Add assets to get smart maintenance' | translate)"
                [priorityIcon]="'assets/img/normal-priority.svg'"
                [address]="addressFilter?.[0]?.viewValue || 'Select Property'"
                [showArrowOnly]="!hasAssets"
                (cardClick)="hasAssets ? addIssueReport() : goToAssets()"
                (rejectClick)="hideSuggestedCard = true"
                (acceptClick)="hasAssets ? addIssueReport() : goToAssets()" />
            }
          }
          <tidy-alert
            *ngIf="!issuesColumns[selectedStatus].length && selectedStatus !== 'reported'"
            class="mobile-empty-alert">
            <tidy-row>
              <tidy-text
                [body]="('No ' | translate) + columnTitlesByKeys[selectedStatus].toLowerCase() + (' maintenance items.' | translate)" />
            </tidy-row>
          </tidy-alert>
        </cdk-virtual-scroll-viewport>
      </ng-container>

    </ng-container>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="!isMobileResolution" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />


<tidy-bottom-nav activeRoute="/maintenance" />